import React from "react";

interface ReviewFieldProps {
  label: string;
  value: React.ReactNode;
}

const ReviewField: React.FC<ReviewFieldProps> = ({ label, value }) => (
  <div className="space-y-1">
    <p className="text-sm text-muted-foreground font-gc-reg">{label}</p>
    <p className="text-sm font-gc-reg text-foreground">{value}</p>
  </div>
);

export default ReviewField;
